"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArtoEn = exports.EntoAr = void 0;
/**
 * English to Arabic digits.
 **/
const EntoAr = function (number) {
    return number.replace(/\d/g, d => '٠١٢٣٤٥٦٧٨٩'[d]);
};
exports.EntoAr = EntoAr;
/**
 * Arabic to English digits.
 **/
const ArtoEn = function (number) {
    return number.replace(/[\u0660-\u0669]/g, d => d.charCodeAt() - 1632);
};
exports.ArtoEn = ArtoEn;
